import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../slices/authSlice";
import driversReducer from '../slices/driverSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    drivers:driversReducer,
    // later: drivers: driverReducer, conductors: conductorReducer, etc.
  },
});

export default store;
